import { t } from "i18next"
export function ContentErrorSection({ small }: { small?: boolean }) {
    return <div className="contentSectionError" style={small ? { maxWidth: "320px", boxSizing: "border-box" } : { boxSizing: "border-box" }}>
        <h2>{t("general-section-broke-title")}</h2>
        <p>{t("general-section-broke-desc")}</p>
    </div>
}